import React from "react";
import { useQwanyx } from "qwanyx";

export const Target = ({
  children,
  target = null,
  tag = "button",
  className = "",
  ...props
}) => {
  const { updateSelectedCard } = useQwanyx();

  const handleClick = (event) => {
    // Run the original onClick if provided
    if (props.onClick) {
      props.onClick(event);
    }

    // If target is provided, update the selected card
    if (target) {
      const cardData = {
        _id: target._id,
        di: target.di,
        ed: target.ed,
        pa: target.pa,
        // Add a timestamp to force re-render even if same target is clicked
        _timestamp: Date.now()
      };

      console.log("Updating card with:", cardData);
      updateSelectedCard(cardData);
    }
  };

  // For button-specific styling
  const elementClass = tag === "button" 
    ? `button ${className}`.trim() 
    : className;

  // Remove onClick from props since we're handling it
  const { onClick, ...restProps } = props;
  
  // Dynamically create the element based on the tag prop
  const Element = tag;

  return (
    <Element
      className={elementClass}
      onClick={handleClick}
      {...restProps}
    >
      {children}
    </Element>
  );
};

export default Target;